var render = function render(){var _vm=this,_c=_vm._self._c;return _c('audio',{ref:"audioPlayer",staticClass:"audio-player",attrs:{"controls":"","src":_vm.fileURL},on:{"ended":_vm.handleEnded}},[_vm._v("\n\t"+_vm._s(_vm.t('spreed', 'Your browser does not support playing audio files'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }